import BookingsSerializer from './base';

export default class Event extends BookingsSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      consecutiveBookings: false,
      slotGap: 0,
      slotLength: 0,
      staffBookingManagement: false,
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
